export function getIconeImg(path) {
  // eslint-disable-next-line global-require,import/no-dynamic-require
  return require(`/static/assets/customactivities/${path}.png`);
}

export function getIconeImgNoExt(path) {
  const noext = path.substring(0, path.indexOf('.'));
  return `/static/assets/customactivities/${noext}..png`;
}

// retourne une chaine de date au format 
// dd/MM/YYYY
export function formatStringDate(sdate) {
  if (!sdate) return null;
  const date = new Date(sdate);
  const year = date.getFullYear();
  const month = `00${date.getMonth() + 1}`.slice(-2);
  const day = `00${date.getDate()}`.slice(-2);

  return `${day}/${month}/${year}`;
}

export function formatStringDateBDD(sdate) {
  if (!sdate) return null;
  const date = new Date(sdate);
  const year = date.getFullYear();
  const month = `00${date.getMonth() + 1}`.slice(-2);
  const day = `00${date.getDate()}`.slice(-2);

  return `${year}-${month}-${day}`;
}


// test si une date est antérieur à maintenant
export function dateBeforeNow(sdate) {
  if (!sdate) return false;
  const date = new Date(sdate);
  return date < new Date() ;
}

// test si une date est supérieru à maintenant
export function dateAfterNow(sdate) {
  if (!sdate) return false;
  const date = new Date(sdate);
  return date > new Date() ;
}

export function compareArraysAndState(existingArray, newArray, key) {
  const arrayObject = [];
  for (let i = 0; i < existingArray.length; i += 1) {
    if (!newArray.includes(existingArray[i])) {
      arrayObject.push({ [key]: existingArray[i], state: 'DEL' });
    }
  }
  for (let i = 0; i < newArray.length; i += 1) {
    if (!existingArray.includes(newArray[i])) {
      arrayObject.push({ [key]: newArray[i], state: 'ADD' });
    }
  }
  return arrayObject;
}

export function normalizeString(str) {
  return str
    .toLowerCase()
    .trim()
    .normalize('NFD') // é => e + ´
    .replace(/[\u0300-\u036f]/g, ''); // supprime les accents (´ ^ ...)
}